'use client'

import { Label, type LabelProps } from 'labels/components/Label/Label'

export function ClientLabel(props: LabelProps) {
	return <Label isClient {...props} />
}
